"use strict";const e=o=>Object.keys(o).map((s=>"@"===s[0]||"&"===s[0]?`${s} {\n                    ${e(o[s])}\n                }`:`${s.split(/(?=[A-Z])/).map((e=>e.toLowerCase())).join("-")}: ${o[s]};`)).join("\n");module.exports=e;
//# sourceMappingURL=index.js.map
